import controller from './img-zoom.controller';
import template from './img-zoom.html';
import './img-zoom.scss';

export default {
	template,
	bindings: {
		image: '<',
		rotate: '<?',
	},
	controller,
};
